import React from "react";

interface HeartIconProps {
  /** true=채운 하트(누름/강조), false=아웃라인 하트(안 누름) */
  filled?: boolean;
  /** 표시 크기(px). 정사각 */
  size?: number;
  /** 색상(채움·선 공통). 기본 브랜드 브라운 */
  color?: string;
  /** 아웃라인 두께 */
  strokeWidth?: number;
  className?: string;
}

// 표준 하트(사용자 선택 = 기존 A). viewBox 24 기준.
const HEART_PATH =
  "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z";

const HeartIcon: React.FC<HeartIconProps> = ({
  filled = false,
  size = 20,
  color = "#6E5B4A",
  strokeWidth = 2,
  className,
}) => (
  // 하트 path bbox=x[2..22]·y[3..21.35]. viewBox 24=여백 커서 작아 보이고(≈83%),
  // 20=박스 꽉 채워 커 보임(100%). 그 중간인 22로(≈91%) 별과 비슷한 체감.
  // stroke halo(1) 포함돼 아웃라인 안 잘림.
  <svg
    width={size}
    height={size}
    viewBox="1 1.2 22 22"
    style={{ overflow: "visible" }}
    fill={filled ? color : "none"}
    stroke={filled ? "none" : color}
    strokeWidth={strokeWidth}
    strokeLinejoin="round"
    strokeLinecap="round"
    className={className}
    aria-hidden="true"
  >
    <path d={HEART_PATH} />
  </svg>
);

export default HeartIcon;
